var React = require('react');

function IconFarseer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.3 61.9c247.4 0 448 200.6 448 448s-200.6 448-448 448-448-200.6-448-448 200.6-448 448-448zm306.3 754.7c20.7 3.5 38-15.9 31.8-36.2.1.2.1.3.2.4l-.3-.8v-.2l-3.2-9.8-38.6-118.4c20.6-43 32.5-90.9 32.5-141.8 0-181.5-147.2-328.7-328.7-328.7S182.6 328.3 182.6 509.8c0 181.6 147.2 328.7 328.7 328.7 63.7 0 123-18.4 173.3-49.7l33.7 7.1c.1 0 .2.1.4.1l97.7 20.5h.4l1.4.3c-.2 0-.4-.2-.6-.2zm-92.1-322.4c0 116.8-94.7 211.5-211.5 211.5S302.5 611 302.5 494.2 397.2 282.7 514 282.7s211.5 94.7 211.5 211.5zm-202.9-81c0 37.6 30.5 68.2 68.2 68.2s68.2-30.5 68.2-68.2-30.5-68.2-68.2-68.2c-37.6.1-68.2 30.6-68.2 68.2zm-32.9 98.1c0 13.4 10.9 24.4 24.3 24.4s24.3-10.9 24.3-24.4c0-13.4-10.9-24.3-24.3-24.3s-24.3 10.9-24.3 24.3z"}));
}

IconFarseer.displayName = "IconFarseer";

IconFarseer.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFarseer;

IconFarseer.default = IconFarseer;
